import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'documentHtml',
})
export class DocumentHtmlPipe implements PipeTransform {
  constructor(private dom: DomSanitizer) {}
  transform(value) {
    return this.dom.bypassSecurityTrustHtml(this.b64DecodeUnicode(value));
    // return this.dom.sanitize(SecurityContext.HTML, this.b64DecodeUnicode(value));
  }

  b64DecodeUnicode(str) {
    //bozuk karakterlerı yok etmek ıcın
    return decodeURIComponent(
      atob(str)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join('')
    );
  }
}
